<template>
	<svg class="ls-icon ls-icon-box" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
		<!-- Icon from Lucide by Lucide Contributors - https://github.com/lucide-icons/lucide/blob/main/LICENSE -->
		<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
			<path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
			<path d="m3.3 7l8.7 5l8.7-5M12 22V12" />
		</g>
	</svg>
</template>
